<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
        <b-card v-else>
            <template header="header" v-slot:header  >
                 <div class="buttons">
                    <b-button :title="$t('general.add')" variant="success" @click="openModal(true,'add')"> {{$t('general.add')}} </b-button>
                </div>
            </template>
            <div class="groups">
                <b-form inline class="formBox"> 
                    <div  class="inputGrp" >
                        <b-table-simple hover responsive>
                            <b-thead>
                                <b-th> {{$t('defination.receivers.no') + ' / ' + $t('defination.receivers.code')}} </b-th>
                                <b-th> {{$t('defination.receivers.name')}} </b-th>
                                <b-th> {{$t('defination.receivers.status')}} </b-th>
                                <b-th> {{$t('general.operation')}} </b-th>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="rec in list" :key="rec.id">
                                    <b-td>{{rec.rec_no + ' - ' + rec.rec_code}}</b-td>
                                    <b-td>{{rec.name}}</b-td>
                                    <b-td>
                                        <b-badge v-if="rec.is_active" variant="success"> Aktif </b-badge>
                                        <b-badge v-else variant="danger"> Pasif </b-badge>
                                    </b-td>
                                    <b-td>
                                        <b-icon icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true"  @click="openModal(true,'edit', rec)"  ></b-icon>
                                        <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" @click="openModal(true, 'delete', rec)"></b-icon>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                   
                </b-form>
            </div>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Modals from './modals/';

    let breadCrumb = [
        { label: i18n.t('pages.defination.name'), url: "/Defination" },
        { label: i18n.t('pages.defination.receiverSettings'), url: "/Defination/Receivers" },
    ]

    
    export default {
        name: "ReceiverSettings",
        data: function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"Receivers",
                modalName: ""
            }
        },
        async created(){
            await this.$store.dispatch("listReceivers");
        },
        components:{
            BreadCrumb, Modals
        },
        methods:{
            openModal: async function(state, modal, props){
                if(modal == 'edit'){
                    await this.$store.dispatch("receiverDetails", props);
                    await this.$store.dispatch("listRecProtocols");
                }
                this.modalOpen = state
                this.modalProps = props
                this.modalName = modal
            },
           
        },
        computed:{
            list(){
                return this.$store.getters.getReceivers;
            },
            loading(){
                return this.$store.getters.getDefinationLoading;
            }
        }
    }
</script>

<style lang="css" scoped > 
    @import "./styles/signalGroups.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/ReceiverSettings.vue